import { PDFDocument } from 'pdf-lib';

/**
 * Haengt ein PDF hinten an ein anderes an.
 *
 * Gebraucht fuer den Leistungsnachweis als Anlage der Rechnung: beide Dokumente
 * entstehen als eigenstaendige jsPDF-Dateien, und jsPDF kann kein zweites
 * Dokument uebernehmen. pdf-lib ist ohnehin Abhaengigkeit (PDF/A-3, LV-Anhang
 * am Angebot) und kann Seiten zwischen Dokumenten kopieren.
 *
 * WICHTIG fuer die Festschreibung: Der Anhang muss VOR dem Hashen entstehen.
 * Wird er spaeter angeklebt, weicht die archivierte Datei von ihrem eigenen
 * sha256 ab, und die Integritaetspruefung schlaegt zu Recht Alarm.
 */
export const appendPdf = async (base: Uint8Array, annex: Uint8Array): Promise<Uint8Array> => {
    // Leere Eingaben durchreichen statt pdf-lib damit zu beschaeftigen: ein
    // leeres Dokument zu laden wirft, und "keine Anlage" ist kein Fehlerfall.
    if (!annex.length) return base;
    if (!base.length) return annex;

    const target = await PDFDocument.load(base);
    const source = await PDFDocument.load(annex);
    const pages = await target.copyPages(source, source.getPageIndices());
    for (const page of pages) target.addPage(page);
    return target.save();
};
